import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'gatsby';
import { Card, Icon } from 'semantic-ui-react';

import './BlogPostCard.css';
import { GatsbyImagePropType } from '../../../../services/proptypes';
import Image from '../../../../atoms/Image';
import ObjectUtils from '../../../../utils/ObjectUtils';

export default class BlogPostCard extends React.PureComponent {
  render() {
    const { slug, title, publishedAt, summary, gatsbyHeroImage, heroImage } = this.props;

    return (
      <Link to={`${slug}`}>
        <Card className="blog-post-card">
          <div style={{ overflow: 'hidden' }}>
            <Image
              className="blog-post-card-image"
              src={gatsbyHeroImage ? gatsbyHeroImage.childImageSharp : heroImage}
              wrapped
            />
          </div>
          <Card.Content>
            <Card.Header>{title}</Card.Header>
            {ObjectUtils.isRenderable(publishedAt) && (
              <Card.Meta>
                <span className="date">{moment(publishedAt).format('LL')}</span>
              </Card.Meta>
            )}
            <Card.Description>{summary}</Card.Description>
          </Card.Content>
          <Card.Content extra textAlign="right">
            <p>
              See More
              <Icon name="right arrow" />
            </p>
          </Card.Content>
        </Card>
      </Link>
    );
  }
}

BlogPostCard.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  publishedAt: PropTypes.string,
  summary: PropTypes.string,
  heroImage: PropTypes.oneOfType([PropTypes.string, GatsbyImagePropType]),
};

BlogPostCard.defaultProps = {
  summary: '',
  heroImage: null,
  publishedAt: null,
};
